/**
 * Forme du `detail` d'une ligne d'appel de fonds.
 *
 * Le générateur OpenAPI le rend en `object` — c'est un jsonb côté API, décrit par une
 * interface TypeScript et non par une classe DTO décorée. On le re-type ici plutôt que de
 * promener des `any` dans les composants.
 */
export interface FundCallLineDetailRow {
  expenseId?: string;
  label: string;
  date?: string;
  share: number;
  creditor?: string;
}

export interface FundCallCreditorGroup {
  creditorLabel: string;
  total: number;
  rows: FundCallLineDetailRow[];
}

export interface FundCallLineDetail {
  rows: FundCallLineDetailRow[];
  creditorGroups: FundCallCreditorGroup[];
  /** Ce que la maison doit au destinataire : affiché, jamais appelé. */
  owedToRecipient: number;
}

export const asFundCallLineDetail = (detail: object): FundCallLineDetail =>
  detail as FundCallLineDetail;
